import { StateSchema } from 'app/config/storeConfig/types';

export const getOpenState = (state: StateSchema): boolean => state.sizeGuideModal.isOpened;
